export default el => {
	const subMenus = el.querySelectorAll('.sub-menu-container');
	
	subMenus.forEach(subMenu => {
		const li = subMenu.closest('li');
		const btn = subMenu.closest('li').querySelector('button');
		if (!btn) return;

		btn.addEventListener('click', () => {
			li.classList.toggle('open');
		})
	})

	const strateHeroHome = document.querySelector('.strate-hero-home');
	document.addEventListener('scroll', (e) => {
		el.classList[window.scrollY > 50 ? 'add' : 'remove']('scrolled');

		if (strateHeroHome) strateHeroHome.classList[window.scrollY > 50 ? 'add' : 'remove']('scrolled');
	})
};